goog.provide("shadow.js.shim.module$ol$proj$fromLonLat");
shadow.js.shim.module$ol$proj$fromLonLat = shadow.js.require(138, {}).fromLonLat;
